import axios from "axios";
import { useEffect, useState } from "react";
import { Box, Card, CircularProgress, Typography } from "@mui/material";
import { WEB_API } from "src/config";

const WEEK_MAP = {
  seg: { label: 'Segunda-feira', order: 0 },
  ter: { label: 'Terça-feira', order: 1 },
  qua: { label: 'Quarta-feira', order: 2 },
  qui: { label: 'Quinta-feira', order: 3 },
  sex: { label: 'Sexta-feira', order: 4 },
  sab: { label: 'Sábado', order: 5 },
  dom: { label: 'Domingo', order: 6 }
}

export default function Schedule() {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.request({
      url: `${WEB_API}/get_schedule`,
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: '*/*'
      }
    }).then(resp => {
      setSchedule(resp.data.map(e => ({ ...e, ...WEEK_MAP[e.weekday] })));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const formatTime = (time) => {
    const n = Number(time);
    if (parseInt(n) !== n) {
      return `${Math.floor(n)}:${(n % 1 * 60).toFixed(0)}`;
    } else {
      return `${n}:00`;
    }
  }

  return (
    <Card sx={{ p: 2, m: 2, borderRadius: 3 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Horários de Atendimento
      </Typography>

      {loading ?
        <CircularProgress />
        :
        // <>
        schedule?.sort((a,b) => a.order - b.order).map(e =>
          <Box key={e.weekday}>
            <Typography variant="h5">
              {e.label}
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              {formatTime(e.start)} - {formatTime(e.end)}
            </Typography>
          </Box>
        )
      }

      {/* <Typography variant="h5">
            Sábado
          </Typography>

          <Typography variant="body1" sx={{ mb: 2 }}>
            {formatTime(schedule.sab?.start)} - {formatTime(schedule.sab?.end)}
          </Typography>

          <Typography variant="h5">
            Domingo
          </Typography>

          <Typography variant="body1" sx={{ mb: 2 }}>
            {formatTime(schedule.dom?.start)} - {formatTime(schedule.dom?.end)}
          </Typography>
        </> */}
    </Card>
  )
}